import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Outlet } from 'react-router-dom';
import IdleTimer from 'react-idle-timer';
import { bindActionCreators, Dispatch } from 'redux';

// Contexts
import { withNavigation } from '../core/TenantProvider';
// Components - Atoms, Molecules, Organisms, Pages
import APFadeTimeoutModal from '../components/organisms/APFadeTimeoutModal';
// Redux
import { ReducerState } from './../redux/modules';
import { actions as SessionActions } from './../redux/modules/session';
// Utils
import { sessionTimeOutWorker } from '../core/utils/Worker/sessionTimeoutWorker';
import { workerScriptLoader } from '../core/utils/Worker/workerScriptLoader';
// Constants
import { AUTO_TIMEOUT_MODAL_OPEN_TIME, AUTO_LOGOUT_TIME_AFTER_MODAL_OPEN } from '../core/utils/Constants/Constants';

const workerInstance = new Worker(workerScriptLoader(sessionTimeOutWorker));

interface SessionTimeoutProps {
    component?: any,
    isAuthenticated?: boolean | null,
    clearSession: Function,
    refresh: Function,
    navigate: any
}

class SessionTimeout extends Component<SessionTimeoutProps, {}> {
    idleTimer: any = null;
    sessionLogoutTimer: number = -1;
    state = {
        showModal: false,
        timeout: AUTO_TIMEOUT_MODAL_OPEN_TIME
    };

    constructor(props) {
        super(props);
        this.idleTimer = React.createRef();
        this.onIdle = this.onIdle.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleLogout = this.handleLogout.bind(this);
        this.onAction = this.onAction.bind(this);
    }

    sessionInterval() {
        workerInstance.postMessage({ msg: 'Logout-post-message', autoLogoutTime: AUTO_LOGOUT_TIME_AFTER_MODAL_OPEN });

        workerInstance.onmessage = (message) => {
            if (message.data === 'call-handleLogout') {
                this.setState({ showModal: false });
                this.handleLogout();
            }
        };

    }

    onAction(e) {
    }

    onIdle(e) {
        this.setState({ showModal: true }, () => {
            this.sessionInterval();
        });
    }

    handleClose() {
        this.setState({ showModal: false });
        this.props.refresh();
        workerInstance.postMessage({ msg: 'clear-timeout' });
    }

    handleLogout() {
        const { navigate } = this.props;
        workerInstance.postMessage({ msg: 'clear-timeout' });

        this.props.clearSession(navigate);
    }

    render() {
        const {
            component: RenderComponent
        } = this.props;

        return (
            <>
                <IdleTimer
                    ref={ref => { this.idleTimer = ref }}
                    element={document}
                    onIdle={this.onIdle}
                    onAction={this.onAction}
                    debounce={250}
                    timeout={this.state.timeout} />

                <APFadeTimeoutModal open={this.state.showModal} pollingProgress={0} handleClose={this.handleClose} />
                <Outlet />
            </>
        );
    }
}

const mapStateToProps = (store: ReducerState) => ({
    isAuthenticated: store.user.isAuthenticated,
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
    clearSession: SessionActions.clearSession,
    refresh: SessionActions.refresh
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withNavigation(SessionTimeout));
